import React, { useEffect } from 'react';
import {
  Box,
  Text,
  Flex,
  Modal,
  Button,
  Divider,
  ModalBody,
  ModalOverlay,
  ModalContent,
  useToast,
} from '@chakra-ui/react';
import FormikSelect from '../../components/forkmikselect';
import FormikInput from '../../components/formikinput';
import { useFormik } from 'formik';
import DataBox from '../../components/databox';
import { ArrowDownIcon } from '@chakra-ui/icons';
import useEditSeller from '../../api/mutations/useEditSeller';

const EditModal = ({ isOpen, onClose, size = 'xl', data }) => {
  const toast = useToast();
  const { mutate: updateSellerStatus, isLoading } = useEditSeller();

  const formik = useFormik({
    initialValues: {
      id: data?.id,
      _id: data?._id,
      full_name: `${data?.first_name || ''} ${data?.surname || ''}`.trim(),
      date_created: data?.date_created,
      approval_status: data?.authUser
        ? data.authUser.verify
          ? 'Approved'
          : 'Pending'
        : '-',
    },
    onSubmit: values => {
      // Split full_name into first_name and surname
      const [first_name, ...surnameParts] = values.full_name.split(' ');
      const surname = surnameParts.join(' ');

      updateSellerStatus(
        {
          _id: values._id,
          first_name: first_name || '',
          surname: surname || '',
          verify: values.approval_status === 'Approved',
        },
        {
          onSuccess: () => {
            toast({
              title: 'Seller updated successfully',
              status: 'success',
              duration: 3000,
              isClosable: true,
            });
            onClose();
          },
          onError: error => {
            toast({
              title: 'Error updating seller',
              description: error.response?.data?.message || error.message,
              status: 'error',
              duration: 5000,
              isClosable: true,
            });
          },
        }
      );
    },
  });

  useEffect(() => {
    if (data) {
      formik.setFieldValue('_id', data._id);
      formik.setFieldValue(
        'full_name',
        `${data?.first_name || ''} ${data?.surname || ''}`.trim()
      );
      formik.setFieldValue(
        'approval_status',
        data?.authUser ? (data.authUser.verify ? 'Approved' : 'Pending') : '-'
      );
    }
  }, [data]);

  return (
    <Modal isOpen={isOpen} onClose={onClose} size={size}>
      <ModalOverlay />
      <ModalContent maxWidth={'800px'} borderRadius={'16px'} p={4}>
        <ModalBody gap={6} display={'flex'} flexDirection={'column'}>
          <Text
            fontSize={'24px'}
            fontFamily={'PlusJakartaSansSemiBold'}
            color={'#000000'}
          >
            Edit Seller Requests
          </Text>
          <Divider borderWidth={'1px'} width={'100%'} color={'#8A8F9333'} />
          <Box>
            <Text
              fontWeight={'600'}
              fontSize={'16px'}
              fontFamily={'PlusJakartaSansSemiBold'}
              color={'#000000'}
              pb={4}
            >
              Request Details
            </Text>
            <Box
              height={'265px'}
              borderRadius={'6px'}
              padding={'16px'}
              border={'1px solid #D9D9D9'}
            >
              <Flex gap={5}>
                <DataBox label={'Requested ID'} data={data?.id} />
              </Flex>
              <Flex gap={5} pt="10px">
                <Box flex="1">
                  <FormikInput
                    formik={formik}
                    name="full_name"
                    label="Seller Name"
                  />
                </Box>
                <Box flex="1">
                  <DataBox
                    label="Request Made on"
                    data={
                      data?.date_created
                        ? new Date(data.date_created)
                          .toISOString()
                          .split('T')[0]
                        : 'N/A'
                    }
                  />
                </Box>
              </Flex>

              <Flex gap={5} pt="10px" mb="10px">
                <FormikSelect
                  formik={formik}
                  name="approval_status"
                  label="Approval Status"
                  placeholder="Select one.."
                >
                  <option value="Approved">Approved</option>
                  <option value="Pending">Pending</option>
                </FormikSelect>
              </Flex>
            </Box>
          </Box>
          <Flex justifyContent={'flex-end'} gap={3}>
            <Button
              onClick={onClose}
              width={'174px'}
              height={'40px'}
              borderRadius={'12px'}
              bg={'none'}
              border={'1px solid #000000'}
              color={'#000000'}
              fontSize={'12px'}
              fontWeight={'500'}
              fontFamily={'PlusJakartaSansMedium'}
              letterSpacing={0.2}
              isDisabled={isLoading}
            >
              CANCEL
            </Button>
            <Button
              onClick={formik.handleSubmit}
              width={'174px'}
              height={'40px'}
              borderRadius={'12px'}
              bg={'#000000'}
              color={'white'}
              fontSize={'12px'}
              fontFamily={'PlusJakartaSansMedium'}
              fontWeight={'500'}
              letterSpacing={0.2}
              isLoading={isLoading}
              loadingText="Saving..."
              isDisabled={
                isLoading ||
                !formik.values.approval_status ||
                formik.values.approval_status === '-'
              }
            >
              SAVE
            </Button>
          </Flex>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

export default EditModal;
